import { api } from '../api';
import { tags } from '../tags';
import type { UserCategoryRecord } from '../types';

export const userCategoryApi = api.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    userCategory: builder.query<UserCategoryRecord, void>({
      query: () => 'api/supportcasecategory/all/',
      providesTags: [tags.userCategory],
      keepUnusedDataFor: 1200,
    }),
  }),
});
